import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  env: 'production' | 'development';
  siteUrl: string;
  isAdminApp: boolean;
  isLocalEnv: boolean;
  apiIntegrationsUrl: string;
  apiAuthUrl: string;
  hostname: string;

  get shouldWatchChanges(): boolean {
    return this.isAdminApp;
  }
}
